import React from 'react'

export const HeadwayIcon: React.FC<{
  width?: string | number
  height?: string | number
}> = ({ width = '21', height = '21' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    role="img"
    aria-label="Headway Icon"
  >
    <g clipPath="url(#clip0_2313_506)">
      <path
        d="M20.3016 12.4893C20.3016 6.5864 15.8102 1.80151 10.2758 1.80151C4.74183 1.80151 0.250006 6.58907 0.250006 12.4893C0.248071 14.3657 0.712157 16.2093 1.59495 17.8331H18.9571C19.8395 16.2093 20.3036 14.3657 20.3016 12.4893Z"
        fill="#13AA65"
      />
    </g>
    <defs>
      <clipPath id="clip0_2313_506">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.25 0.69043)"
        />
      </clipPath>
    </defs>
  </svg>
)
